import React from 'react';
import { Modal } from '@scuf/common';
import './AgreementModal.scss';
import { EULAAgreementText } from '../UnauthenticatedPages/EULAAgreementText';
import { PrivacyPolicyText } from '../UnauthenticatedPages/PrivacyPolicyText';

interface IAgreementModalProps {
  languageCode: string;
  title: string;
  type: string;
  onClose: (version: string) => void;
}

const AgreementModal = (props: IAgreementModalProps) => {
  const VERSION = '1';
  return (
    <Modal
      closeOnDimmerClick={false}
      closeOnDocumentClick={false}
      closeIcon={true}
      onClose={() => props.onClose(VERSION)}
      open={true}
      size="large"
      className='terms-and-cond-agreement-modal'
    >
      <Modal.Header>{props.title}</Modal.Header>
      <Modal.Content>
        {props.type === 'EULA' ? EULAAgreementText(props.languageCode) : PrivacyPolicyText(props.languageCode)}
      </Modal.Content>
    </Modal>
  );
};

export default AgreementModal;
